import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Alert, Button } from "react-bootstrap";
import { HiOutlineShieldCheck } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../config/routes";
import "./VerificationNoticeBanner.css";
export default function VerificationNoticeBanner({
  user
}) {
  useLanguage();
  const navigate = useNavigate();
  const isProfileComplete = user?.profile_status === "complete";
  const isNafathVerified = user?.nafath_status === "verified";
  if (!isProfileComplete || isNafathVerified) {
    return null;
  }
  return <div className="bb-verification-banner-wrap">
      <Alert className="bb-verification-banner" variant="warning">
        <div className="bb-verification-banner__content">
          <div className="bb-verification-banner__icon">
            <HiOutlineShieldCheck />
          </div>

          <div className="bb-verification-banner__text">
            <h6 className="bb-verification-banner__title">{t("Complete your Nafath verification")}

            </h6>
            <p className="bb-verification-banner__description">{t("Nafath verification is a one-time step that unlocks key BaytBuddy features such as posting a room and viewing lister contact details. It will also help you access upcoming features in future app updates.")}




            </p>
          </div>

          <div className="bb-verification-banner__actions">
            <Button variant="warning" className="bb-verification-banner__btn" onClick={() => navigate(ROUTES.NAFATH_VERIFICATION)}>{t("Verify Now")}


            </Button>
          </div>
        </div>
      </Alert>
    </div>;
}
